<body>
  <div *ngIf="loading" class="loader-overlay" >
    <div class="loader"></div>
  </div>
  <div class="container-xxl">
    <div class="authentication-wrapper authentication-basic container-p-y">
      <div class="authentication-inner">
        <!-- Register -->
        <div class="card">
          <div class="card-body">
            <!-- Logo -->
            <div class="app-brand justify-content-center app-brand-link">
              <!-- 守<span class="brand-sub">るん</span>99<span class="brand-logo-note">（※ロゴなどを配置）</span> -->
              守<span class="brand-sub">るん</span>99<span class="brand-logo-note"></span>
            </div>
            <!-- /Logo -->

            <!-- <h4 class="mb-2">Welcome to Medi Shop</h4> -->
            <!-- <p class="mb-4">Please sign-in to your account and start the adventure</p> -->

            <form  [formGroup]="loginForm" (ngSubmit)="onSubmit()">
              <div class="mb-3">
                <label for="email" class="form-label">メールアドレス</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  name="email-username"
                  formControlName=email
                  maxlength="50"
                  placeholder="メールアドレス"
                  autofocus
                  required
                />
                <div class="error" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.hasError('required')">
                  入力してください。
                </div>
                <div class="error" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.hasError('pattern')">
                  電子メールが無効です。
                </div>
              </div>
              <div class="mb-3 form-password-toggle">
                <div class="d-flex justify-content-between">
                  <label class="form-label" for="password">パスワード</label>
                  <a href="auth-forgot-password-basic.html">
                    <!-- <small>Forgot Password?</small> -->
                  </a>
                </div>
                <div class="input-group input-group-merge">
                  <input
                    [type]="showPassword ? 'text' : 'password'"
                    id="password"
                    class="form-control"
                    name="password"
                    autocomplete="password"
                    formControlName=password
                    placeholder="パスワード"
                    maxlength="50"
                    aria-describedby="password"
                    required
                  />
                  <span class="input-group-text cursor-pointer" (click)="togglePassword()">
                    <i class="bx bx-hide" [ngClass]="showPassword ? 'bx-show' : 'bx-hide'"></i>
                  </span>
                </div>
                <div class="error" *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
                  パスワードが必要です。
                </div>

              </div>
              <div class="mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="remember-me" />
                  <label class="form-check-label" for="remember-me">ログイン情報を記憶</label>
                </div>
              </div>
              <div class="mb-3">
                <button type="submit" class="login-btn">
                  サインイン
                </button>
              </div>
            </form>
          </div>
        </div>
        <!-- /Register -->
      </div>
    </div>
  </div>
</body>
